import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import sanitizeHtml from 'sanitize-html'

const SanitizedHtml = React.forwardRef(
    ({html, as: Component = Box, sanitize = false, ...props}, ref) => {
        const c_sanitizedHtml = sanitize ? sanitizeHtml(html || '') : html
        return (
            <Component
                ref={ref}
                className="editorial--html-block"
                {...props}
                dangerouslySetInnerHTML={{__html: c_sanitizedHtml}}
            />
        )
    },
)

SanitizedHtml.propTypes = {
    html: PropTypes.string,
    as: PropTypes.elementType,
    sanitize: PropTypes.bool,
}

SanitizedHtml.displayName = 'SanitizedHtml'

export default SanitizedHtml
